const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              
              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  } 
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();                                    
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

// Hover/focus a metafield colour swatch (.card__swatch) → preview that colour's
// product image in the card. Mirrors the Tailored product grid behaviour.
const bindSwatchImagePreview = () => {
  document.querySelectorAll('.card-wrapper').forEach(wrapper => {
    const swatches = Array.from(wrapper.querySelectorAll('.card__swatch[data-main-src]'));
    if (swatches.length === 0) return;

    const primary = wrapper.querySelector('.media--first');
    const secondary = wrapper.querySelector('.media--second');
    if (!primary || wrapper.dataset.swatchPreviewBound === 'true') return;
    wrapper.dataset.swatchPreviewBound = 'true';

    const defaultSrc = primary.getAttribute('src') || '';
    const defaultSrcset = primary.getAttribute('srcset') || '';

    const preview = (src, srcset) => {
      if (!src) return;
      if (src !== primary.getAttribute('src')) {
        primary.setAttribute('src', src);
        if (srcset) primary.setAttribute('srcset', srcset);
        else primary.removeAttribute('srcset');
      }
      // Force the (swapped) primary image to show over the secondary hover image.
      primary.style.opacity = '1';
      if (secondary) secondary.style.opacity = '0';
    };

    const reset = () => {
      primary.setAttribute('src', defaultSrc);
      if (defaultSrcset) primary.setAttribute('srcset', defaultSrcset);
      primary.style.removeProperty('opacity');
      if (secondary) secondary.style.removeProperty('opacity');
    };

    swatches.forEach(sw => {
      const src = sw.getAttribute('data-main-src') || '';
      const srcset = sw.getAttribute('data-main-srcset') || '';
      if (!src) return;
      const onEnter = () => preview(src, srcset);
      sw.addEventListener('mouseenter', onEnter);
      sw.addEventListener('focus', onEnter);
    });

    wrapper.addEventListener('mouseleave', reset);

    // Preload sibling images during idle time so the swap is instant.
    const preload = () => {
      const seen = new Set();
      swatches.forEach(sw => {
        const src = sw.getAttribute('data-main-src');
        if (!src || seen.has(src)) return;
        seen.add(src);
        const img = new Image();
        const srcset = sw.getAttribute('data-main-srcset');
        if (srcset) img.srcset = srcset;
        img.src = src;
      });
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(preload, { timeout: 2000 });
    else window.setTimeout(preload, 600);
  });
};

function colorSwatchImagePreview() {
  bindSwatchImagePreview();
  document.addEventListener('shopify:section:load', bindSwatchImagePreview);
}

(function () {
colorSwatches();
colorSwatchImagePreview();
})()